import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

// Catálogo do módulo (U33). `eager`: os títulos dos manifestos aparecem no ⌘K e no breadcrumb antes de
// a tela abrir, e as fontes de busca (F0) rotulam as opções mesmo sem rota do módulo (S31).
registerModuleCatalog('person', (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });

export function loadPersonMessages(): Promise<void> {
  return ensureModuleMessages('person');
}
